import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex-shrink-0 bg-gray-900 px-2 pb-3" }
const _hoisted_2 = { class: "overflow-hidden rounded-lg border border-gray-700 bg-black" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "min-w-0 flex-1" }
const _hoisted_5 = { class: "truncate text-sm font-semibold text-gray-200 group-hover:text-gray-100" }
const _hoisted_6 = { class: "truncate text-xs font-medium text-gray-400 group-hover:text-gray-300" }
const _hoisted_7 = { class: "space-y-1 p-1.5" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "truncate" }
const _hoisted_10 = { class: "truncate" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "flex items-center gap-3 px-2 pt-1 pb-0.5 text-[11px] text-gray-400" }
const _hoisted_13 = ["href"]

import { InformationCircleIcon } from '@heroicons/vue/20/solid'
import {
  ArrowUpRightIcon,
  ChevronRightIcon,
  GlobeAmericasIcon,
  PhoneIcon,
  QuestionMarkCircleIcon
} from '@heroicons/vue/24/outline'
import { computed } from 'vue'

import { LEGAL_LINKS } from '@/config/legal'
import { HELP_URL } from '@/config/navSections'
import { SETTINGS_ROOT } from '@/config/settingsTabs'
import { navTourTarget } from '@/config/tours'

// The phone row is the one row that goes nowhere, so it carries neither the
// hover treatment nor the group that drives the icon's hover colour.
const ROW_CLASSES = 'flex items-center gap-2.5 w-full rounded-md px-2 py-1.5 text-[13px] font-medium text-gray-300'
const ICON_CLASSES = 'text-gray-400 group-hover:text-gray-300 h-3.5 w-3.5 shrink-0'
const STATIC_ICON_CLASSES = 'text-gray-400 h-3.5 w-3.5 shrink-0'


export default {
  __name: 'SidebarAccountCard',
  props: {
  name: { type: String, default: '' },
  avatar: { type: String, default: '' },
  subdomain: { type: String, default: '' },
  phone: { type: String, default: '' },
  highlighted: { type: Boolean, default: false },
  subtitle: { type: String, default: 'Settings' },
  to: { type: String, default: SETTINGS_ROOT }
},
  emits: ['navigate'],
  setup(__props, { emit: __emit }) {

const LINK_CLASSES = `transition-all group ${ROW_CLASSES} hover:bg-gray-600 hover:text-gray-200`
const props = __props
const emit = __emit

const siteUrl = computed(() => 'https://' + props.subdomain)

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")
  const _directive_tippy = _resolveDirective("tippy")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: __props.to,
        "data-tour": _unref(navTourTarget)(__props.to),
        class: _normalizeClass(["group flex w-full items-center gap-3 p-3 text-left transition-colors", __props.highlighted && 'bg-gray-800']),
        onClick: _cache[0] || (_cache[0] = $event => (emit('navigate')))
      }, {
        default: _withCtx(() => [
          (__props.avatar)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "inline-block h-9 w-9 shrink-0 rounded-md bg-white",
                src: __props.avatar
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(__props.name), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(__props.subtitle), 1)
          ]),
          _createVNode(_unref(ChevronRightIcon), {
            class: "h-3.5 w-3.5 shrink-0 text-gray-400 group-hover:text-gray-300",
            "aria-hidden": "true"
          })
        ]),
        _: 1
      }, 8, ["to", "data-tour", "class"]),
      _cache[9] || (_cache[9] = _createElementVNode("hr", { class: "mx-3 border-gray-800" }, null, -1)),
      _createElementVNode("div", _hoisted_7, [
        (__props.subdomain)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: siteUrl.value,
              target: "_blank",
              rel: "noopener",
              class: _normalizeClass(LINK_CLASSES),
              onClick: _cache[1] || (_cache[1] = $event => (emit('navigate')))
            }, [
              _createVNode(_unref(GlobeAmericasIcon), {
                class: _normalizeClass(ICON_CLASSES),
                "aria-hidden": "true"
              }),
              _createElementVNode("span", _hoisted_9, _toDisplayString(__props.subdomain), 1),
              _createVNode(_unref(ArrowUpRightIcon), {
                class: "h-3 w-3 shrink-0",
                "aria-hidden": "true"
              }),
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "sr-only" }, "(opens in a new tab)", -1))
            ], 8, _hoisted_8))
          : _createCommentVNode("", true),
        (__props.phone)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(ROW_CLASSES)
            }, [
              _createVNode(_unref(PhoneIcon), {
                class: _normalizeClass(STATIC_ICON_CLASSES),
                "aria-hidden": "true"
              }),
              _createElementVNode("span", _hoisted_10, _toDisplayString(__props.phone), 1),
              _withDirectives(_createVNode(_unref(InformationCircleIcon), {
                class: _normalizeClass(STATIC_ICON_CLASSES),
                "aria-hidden": "true"
              }, null, 512), [
                [_directive_tippy, {
              content: 'This is your Bottle-assigned phone number',
              placement: 'right',
              theme: 'dark'
            }]
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "sr-only" }, "is your Bottle-assigned phone number", -1))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("a", {
          href: _unref(HELP_URL),
          target: "_blank",
          rel: "noopener",
          class: _normalizeClass(LINK_CLASSES),
          onClick: _cache[2] || (_cache[2] = $event => (emit('navigate')))
        }, [
          _createVNode(_unref(QuestionMarkCircleIcon), {
            class: _normalizeClass(ICON_CLASSES),
            "aria-hidden": "true"
          }),
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "truncate" }, "Help", -1)),
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "sr-only" }, "(opens in a new tab)", -1))
        ], 8, _hoisted_11),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(LEGAL_LINKS), (link) => {
            return (_openBlock(), _createElementBlock("a", {
              key: link.href,
              href: link.href,
              target: "_blank",
              rel: "noopener",
              class: "transition-all hover:text-gray-200",
              onClick: _cache[3] || (_cache[3] = $event => (emit('navigate')))
            }, [
              _createTextVNode(_toDisplayString(link.label) + " ", 1),
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "sr-only" }, "(opens in a new tab)", -1))
            ], 8, _hoisted_13))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

}